/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { httpRequest } from "./httpRequest";
import { modal } from "./modal";
import { updateList, updateHTML } from "./pagination";
import { updateCustomSelectValue } from "./customSelects";
import { loadingElement } from "./utils/loadingElement";
import { getAllUncheckedCheckboxes } from "./utils/functions";

// import {updateHTML, updateListing} from "./filter-pagination";

export function handleFormData(form) {
  if (form instanceof HTMLElement && form.tagName.toLowerCase() === "form") {
    var formData = new FormData(form);
    var uncheckedCheckboxes = getAllUncheckedCheckboxes(form);
    uncheckedCheckboxes.forEach(function (element) {
      return formData.append(element, "0");
    });
    return Array.from(formData, function (_ref) {
      var key = _ref[0],
        value = _ref[1];
      return [key, typeof value === 'string' ? value : value.name];
    });
  }
}

/**
 *
 * @param formId
 * @param isList
 * @param isHTML
 * @param reloadPage
 * @param listContainerId
 * @param modalId
 * @param validation
 * @param prevModalId
 * @param controlId
 * @property {string} objectType
 */
export function saveForm(_ref2) {
  var formId = _ref2.formId,
    _ref2$isList = _ref2.isList,
    isList = _ref2$isList === void 0 ? false : _ref2$isList,
    _ref2$isHTML = _ref2.isHTML,
    isHTML = _ref2$isHTML === void 0 ? false : _ref2$isHTML,
    _ref2$reloadPage = _ref2.reloadPage,
    reloadPage = _ref2$reloadPage === void 0 ? false : _ref2$reloadPage,
    listContainerId = _ref2.listContainerId,
    _ref2$modalId = _ref2.modalId,
    modalId = _ref2$modalId === void 0 ? null : _ref2$modalId,
    _ref2$validation = _ref2.validation,
    validation = _ref2$validation === void 0 ? true : _ref2$validation,
    _ref2$prevModalId = _ref2.prevModalId,
    prevModalId = _ref2$prevModalId === void 0 ? '' : _ref2$prevModalId,
    controlId = _ref2.controlId;
  var form = document.getElementById(formId);
  if (!form) return console.warn(adminConfig.messages.formIdNotSpecified);
  var route = form.action;
  if (!route) return console.warn(adminConfig.messages.routeNotSpecified);
  var formDataArray = handleFormData(form);
  var queryString = new URLSearchParams(formDataArray).toString();
  if (validation) {
    adminConfig.forms[formId].validate();
  }
  // console.info(formDataArray)
  if (adminConfig.forms[formId].validate()) {
    loadingElement.start(form);
    httpRequest({
      url: route,
      data: queryString
    }).then(function (response) {
      if (response && response.data && !response.data.error) {
        // change init value after save changes

        // let remoteElements = form.querySelectorAll('[data-pristine-remote]');
        // for (let i = 0; i < remoteElements.length; i++) {
        // 	remoteElements[i].dataset.initValue = remoteElements[i].value;
        // }
        if (reloadPage) {
          location.reload();
        }
        if (isList) {
          updateList({
            containerId: listContainerId
          });
        }
        // console.warn(isHTML)
        if (isHTML) {
          updateHTML(listContainerId, response.data.html);
        }
        if (modalId) {
          modal.remove(modalId);
        }
        if (prevModalId) {
          modal.update(prevModalId);
        }
        if (controlId && response.data.object && response.data.object.objectType) {
          var object = response.data.object;
          var searchSelectOptionName;
          var searchSelectOptionId = object.id;
          if (object.objectType === 'author') {
            searchSelectOptionName = "" + (object.firstName ? object.firstName + ' ' : '') + (object.lastName ? object.lastName : '');
          } else {
            searchSelectOptionName = object.name;
          }
          console.log('searchSelectOptionId', searchSelectOptionId);
          console.log('searchSelectId [controlId]', controlId);
          console.log('searchSelectOptionName', searchSelectOptionName);
          updateCustomSelectValue(controlId, searchSelectOptionId, searchSelectOptionName);
        }
      }
    })["finally"](function () {
      loadingElement.finish(form);
    });
  } else {
    console.info(adminConfig.forms[formId].getErrors());
    console.warn(adminConfig.messages.formNotValid);
  }
}
export function saveFormInit() {
  document.addEventListener("click", function (e) {
    if (!e.target.matches(".save-form")) return;
    e.preventDefault();
    var containerId = e.target.dataset.container;
    var isList = e.target.dataset.list === 'true';
    var isHTML = e.target.dataset.html === 'true';
    var reloadPage = e.target.dataset.reload === 'true';
    var formId = e.target.dataset.form;
    var modalId = e.target.dataset.modal;
    var prevModalId = e.target.dataset.prevModal;
    var controlId = e.target.dataset.control;
    saveForm({
      formId: formId,
      isList: isList,
      isHTML: isHTML,
      reloadPage: reloadPage,
      listContainerId: containerId,
      modalId: modalId,
      prevModalId: prevModalId,
      controlId: controlId
    });
  });
}